import React, { useEffect, useRef, useState, useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { routes } from '../routes/routes-names';
import * as Yup from "yup";
import * as cam from "@mediapipe/camera_utils";
import { FaceMesh } from "@mediapipe/face_mesh";
import {  useLocation, useNavigate,useSearchParams } from "react-router-dom";
import moment from "moment";
import { eventService } from "../lib/api/event";
import "bootstrap/dist/css/bootstrap.min.css";
import Swal from "sweetalert2";

const CameraCapture: React.FC = () => {
  const { state } = useLocation();
  const { doctorId, doctorName, eventId, day, isSubsequentDay } = state || {};

  const [params] = useSearchParams();
  const token = params.get("token");



  const navigate = useNavigate();


  const validationSchema = Yup.object({
    eventId: Yup.string().required("Event Name is required"),
    attendanceRole: Yup.string().required("Role is required"),
    name: Yup.string().required("Doctor Name is required"),
    fmrNo: Yup.string().required("FMR Number is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    mobileNo: Yup.string()
      .matches(/^[0-9]{10}$/, "Enter valid 10-digit number")
      .required("Mobile number is required"),
  });

  const handleSubmit = async (values: any) => {
    await uploadPhoto(values);
  };
  const validationSchemaDaily = Yup.object({
    attendanceRole: Yup.string().required("Role is required"),
  });
const [fmrLoading, setFmrLoading] = useState(false);
  const [mobileLookupLoading, setMobileLookupLoading] = useState(false);
  const [hasMobileLookupData, setHasMobileLookupData] = useState(false);
  const [hasFmrNameData, setHasFmrNameData] = useState(false);
  const [hasFmrEmailData, setHasFmrEmailData] = useState(false);
  const [hasFmrMobNoData, setHasFmrMobNoData] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);
  const [captured, setCaptured] = useState<string | null>(null);
  const [status, setStatus] = useState('Camera is off. Click "Caputure Photo" to start.');
  const [isBlinking, setIsBlinking] = useState(false);
  const [latitude, setLatitude] = useState<number>(0);
  const [longitude, setLongitude] = useState<number>(0);
  const [lastBlink, setLastBlink] = useState<number>(0);
  const [photoReady, setPhotoReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [eventTypes, setEventTypes] = useState<{ id: number; nameOfEvent: string; startDate?: string }>();
  const [cameraActive, setCameraActive] = useState(false);
  const [faceCount, setFaceCount] = useState(0);
  const [facingMode, setFacingMode] = useState<"user" | "environment">("user");
  const [emailFocused, setEmailFocused] = useState(false);
  const [mobileFocused, setMobileFocused] = useState(false);
  const isSubsequentDayFlow = (() => {
    if (isSubsequentDay === true) return true;
    const selectedDayRaw = (day ?? "").toString().trim();
    const eventStartRaw = (eventTypes?.startDate ?? "").toString().trim();
    if (!selectedDayRaw || !eventStartRaw) return false;
    const selectedDayMoment = moment(selectedDayRaw, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601]);
    const eventStartMoment = moment(eventStartRaw, ["DD-MM-YYYY", "YYYY-MM-DD", moment.ISO_8601]);
    if (!selectedDayMoment.isValid() || !eventStartMoment.isValid()) return false;
    return !selectedDayMoment.isSame(eventStartMoment, "day");
  })();
  const LIVENESS_WINDOW_MS = 5000; // must blink within last 5s before capture
  const cameraRef = useRef<cam.Camera | null>(null);
  const streamRef = useRef<MediaStream | null>(null);
  const capturingRef = useRef(false);
  const photoReadyRef = useRef(false);
  useEffect(() => {
    photoReadyRef.current = photoReady;
  }, [photoReady]);
  const stopStream = useCallback(async () => {
    if (cameraRef.current) {
      try {
        await cameraRef.current.stop();
      } catch (e) {
        console.warn("camera stop warning:", e);
      }
    }
    streamRef.current?.getTracks().forEach((t) => t.stop());
    if (videoRef.current) videoRef.current.srcObject = null;
    cameraRef.current = null;
    streamRef.current = null;
    // give the device a moment to release (mobile devices need longer)
    await new Promise((res) => setTimeout(res, 300));
  }, []);


  const getLocation = () => {

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log("Latitude:", position.coords.latitude);
          console.log("Longitude:", position.coords.longitude);
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
          // Combine this data with your captured photo
        },
        (error) => {
          console.error("Error getting location:", error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const maskEmailDisplay = (email: string) => {
    if (!email) return "";
    const atIndex = email.indexOf("@");
    if (atIndex === -1) return email;
    const visible = email.slice(0, atIndex);
    const hiddenLength = Math.max(email.length - atIndex, 0);
    return `${visible}${"*".repeat(hiddenLength)}`;
  };

  const maskMobileDisplay = (mobile: string) => {
    if (!mobile) return "";
    const trimmed = mobile.toString();
    if (trimmed.length <= 4) return trimmed;
    return `${"*".repeat(trimmed.length - 4)}${trimmed.slice(-4)}`;
  };

  const resolveDoctorRegion = (payload: any, fallbackFmrNo?: string): "" | "telangana" | "non-telangana" => {
    const regionRaw = (
      payload?.doctorRegion ??
      payload?.region ??
      payload?.state ??
      payload?.doctorState ??
      ""
    )
      .toString()
      .trim()
      .toLowerCase();

    if (regionRaw.includes("telangana") || regionRaw === "tg" || regionRaw === "ts") {
      return "telangana";
    }
    if (regionRaw.length > 0) {
      return "non-telangana";
    }

    const fmrNo = (payload?.fmrNo ?? fallbackFmrNo ?? "").toString().trim().toUpperCase();
    if (fmrNo.startsWith("TSMC") || fmrNo.startsWith("TGMC")) {
      return "telangana";
    }
    return "";
  };

  const resolveAttendanceRole = (payload: any): "" | "delegate" | "speaker" => {
    const directRole = (
      payload?.attendanceRole ??
      payload?.attendingAs ??
      payload?.role ??
      ""
    )
      .toString()
      .trim()
      .toLowerCase();

    if (directRole === "delegate" || directRole === "speaker") {
      return directRole;
    }

    const attendanceList = Array.isArray(payload?.attendanceList) ? payload.attendanceList : [];
    for (let i = attendanceList.length - 1; i >= 0; i--) {
      const listRole = (
        attendanceList[i]?.attendanceRole ??
        attendanceList[i]?.attendingAs ??
        attendanceList[i]?.role ??
        ""
      )
        .toString()
        .trim()
        .toLowerCase();
      if (listRole === "delegate" || listRole === "speaker") {
        return listRole;
      }
    }

    return "";
  };

  useEffect(() => {
    if (token) {
      sessionStorage.setItem("ATTENDANCE_TOKEN", token);
    }
  }, [token]);

  const getEventsbyOrgid = useCallback(async () => {
    try {
      if (!eventId) return;
      const { data } = await eventService.getEventById(eventId);
      setEventTypes(data);
    } catch (e) {
      console.warn("getEventsbyOrgid error:", e);
    }
  }, [eventId]);
  // Run once to load location & events
  useEffect(() => {
    getLocation();
    getEventsbyOrgid();
  }, [getEventsbyOrgid]);

  // Keep a single FaceMesh instance across camera lifecycle
  const faceMeshRef = useRef<FaceMesh | null>(null);

  // Start camera only after user clicks the button
  useEffect(() => {
    if (!cameraActive) return;

    let camera: cam.Camera | null = null;
    let stream: MediaStream | null = null;
    setStatus("Initializing camera...");

    const init = async () => {
      try {
        if (!videoRef.current) return;

        // defensive: ensure previous stream fully stopped before requesting new one
        await stopStream();

        // Build (or reuse) a single FaceMesh instance
        const faceMesh =
          faceMeshRef.current ||
          new FaceMesh({
            locateFile: (file) =>
              `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`,
          });

        faceMesh.setOptions({
          maxNumFaces: 1,
          refineLandmarks: true,
          minDetectionConfidence: 0.5,
          minTrackingConfidence: 0.5,
        });

        faceMesh.onResults(onResults);
        // Ensure graph is fully initialized before sending frames (some builds expose initialize)
        const initializer = (faceMesh as any).initialize;
        if (typeof initializer === "function") {
          await initializer.call(faceMesh);
        }
        faceMeshRef.current = faceMesh;

        camera = new cam.Camera(videoRef.current, {
          onFrame: async () => {
            if (videoRef.current) {
              await faceMesh.send({ image: videoRef.current });
            }
          },
          width: 640,
          height: 480,
          facingMode,
        });

        await camera.start();
        // store the stream created by camera_utils so we can stop it explicitly
        streamRef.current = (videoRef.current.srcObject as MediaStream) || null;
        cameraRef.current = camera;
        setStatus("Align your face and blink to capture...");
      } catch (err: any) {
        console.error("Failed to acquire camera feed:", err);
        // On some mobile devices, 'environment' camera isn't available or still locked; fall back to front.
        if (
          (err?.name === "NotReadableError" || err?.name === "OverconstrainedError") &&
          facingMode === "environment"
        ) {
          await stopStream();
          setStatus("Rear camera unavailable; switching to front camera.");
          setCameraActive(false);
          setFacingMode("user");
          setTimeout(() => setCameraActive(true), 400);
          return;
        }

        Swal.fire("Error", err?.message || "Camera permission denied", "error");
        setStatus("Camera failed to start. Check permissions or if another app is using the camera.");
        setCameraActive(false);
      }
    };

    init();

    return () => {
      stopStream();
    };
  }, [cameraActive, facingMode, stopStream]);



  const prevEyesClosedRef = useRef(false);
  const closedStartRef = useRef<number | null>(null);
  const closedQualifiedRef = useRef(false);
  const baselineEarRef = useRef(0.0); // running average of open-eye EAR
  const baselineCountRef = useRef(0);

  const onResults = (results: any) => {
    const faces = results.multiFaceLandmarks?.length || 0;
    setFaceCount(faces);

    if (faces === 0) {
      return;
    }

    if (faces > 1) {
      closedQualifiedRef.current = false;
      setIsBlinking(false);
      return;
    }

    const landmarks = results.multiFaceLandmarks[0];
    // Once we have a captured photo, ignore further detection until reset
    if (photoReady || !cameraActive) return;

    const ear = getEyeAspectRatio(landmarks);

    const now = Date.now();
    // Build a baseline EAR from open-eye frames for adaptive thresholds
    if (!prevEyesClosedRef.current && !isBlinking) {
      const prevAvg = baselineEarRef.current;
      const n = baselineCountRef.current;
      // simple running average to avoid storing history
      baselineEarRef.current = prevAvg + (ear - prevAvg) / (n + 1);
      baselineCountRef.current = n + 1;
    }

    const baselineEar = Math.max(baselineEarRef.current || ear, 0.18); // fallback
    const closeThreshold = Math.min(baselineEar * 0.85, 0.25); // require ~15% drop, cap absolute
    const openThreshold = baselineEar * 0.88; // reopen threshold a bit lower (less strict)

    const eyesClosed = ear < closeThreshold;
    const eyesOpen = ear > openThreshold;

    // mark when eyes first fully close
    if (eyesClosed && !prevEyesClosedRef.current) {
      closedStartRef.current = now;
    }

    // qualify blink only after sustained closure
    if (eyesClosed && closedStartRef.current) {
      const closedDuration = now - closedStartRef.current;
      if (closedDuration >= 250) {
        closedQualifiedRef.current = true; // fully closed long enough
      }
    }

    // trigger only if closure qualified, then clear open
    if (
      closedQualifiedRef.current &&
      eyesOpen &&
      !isBlinking &&
      now - lastBlink > 2000
    ) {
      closedQualifiedRef.current = false;
      setIsBlinking(true);
      setLastBlink(now);
      setStatus("Blink detected! Capturing photo...");
      // auto-capture on blink without extra gates; allow capture even if face count flickers
      capturePhoto(false, false);

      setTimeout(() => {
        setIsBlinking(false);
        // no follow-up status; keep whatever capturePhoto set
      }, 1500);
    }

    prevEyesClosedRef.current = eyesClosed;

    // reset timers when eyes are open
    if (!eyesClosed) {
      closedStartRef.current = null;
    }
  };


  const capturePhoto = (
    requireSingleFace: boolean = true,
    requireLiveness: boolean = true
  ) => {
    if (capturingRef.current) return;
    capturingRef.current = true;

    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    if (requireSingleFace && faceCount !== 1) {
      capturingRef.current = false;
      return;
    }
    if (requireLiveness) {
      const now = Date.now();
      if (!lastBlink || now - lastBlink > LIVENESS_WINDOW_MS) {
        setStatus("Please blink to verify liveness before capture.");
        capturingRef.current = false;
        return;
      }
    }

    // ensure video has dimensions ready (some mobile browsers lag)
    const track = streamRef.current?.getVideoTracks()[0];
    const settings = track?.getSettings ? track.getSettings() : {};
    // fallback to reasonable defaults so we still capture even if metadata not ready
    const vw =
      video.videoWidth ||
      (settings.width as number) ||
      video.clientWidth ||
      640;
    const vh =
      video.videoHeight ||
      (settings.height as number) ||
      video.clientHeight ||
      480;

    canvas.width = vw;
    canvas.height = vh;
    const ctx = canvas.getContext("2d");
    if (!ctx) {
      capturingRef.current = false;
      return;
    }
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const dataUrl = canvas.toDataURL("image/jpeg");
    setCaptured(dataUrl);
    setPhotoReady(true);
    photoReadyRef.current = true; // immediate sync for timers
    setStatus("Photo captured and frozen. Tap Recapture to retake.");
    stopStream().finally(() => {
      setCameraActive(false);
      capturingRef.current = false;
    });
  };

  const toggleCamera = async () => {
    const wasActive = cameraActive;
    const nextFacing = facingMode === "user" ? "environment" : "user";

    // stop current stream/camera before switching
    await stopStream().catch((e) => console.warn("Camera stop warning:", e));
    setCameraActive(false);
    setStatus(`Switching to ${nextFacing === "user" ? "Front" : "Rear"} camera...`);
    setFacingMode(nextFacing);
    if (wasActive) {
      // restart on the new camera
      setTimeout(() => setCameraActive(true), 300);
    }
  };

  const resetCapture = () => {
    setCaptured(null);
    setPhotoReady(false);
    photoReadyRef.current = false;
    setStatus("Ready - blink again to capture a new photo.");
    setCameraActive(true);
    capturingRef.current = false;
  };

  const uploadPhoto = async (values: any) => {
    if (!captured) {
      Swal.fire({
        title: "Error",
        text: "Photo not captured",
        icon: "error",
        confirmButtonText: "OK",
      })
      return;
    }
    setStatus("Uploading...");
    setLoading(true);

    try {
      const blob = await (await fetch(captured)).blob();
      const photData = new FormData();
      photData.append("photo", blob, "blink.jpg");
      const doctorregInfo = {
        eventId: values.eventId,
        doctorName: values.name,
        attendanceRole:values.attendanceRole,
        email: values.email,
        fmrNo: values.fmrNo,
        contactNumber: values.mobileNo,
        latitude: latitude,
        longitude: longitude,
        createdon: moment().format('YYYY-MM-DD'),
        posttime: moment().format('h:mm:ss'),
      }
      photData.append("doctorregInfo", JSON.stringify(doctorregInfo));

      const { success, message, data } = await eventService.saveDoctorPhoto(photData);
      if (success) {
        setLoading(false);
        Swal.fire({
          title: "success",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: message,
          icon: "error",
          confirmButtonText: "OK",
        });

      }
      navigate(routes.eventDocInfo);
      setStatus("Photo uploaded successfully!");
    } catch (err) {
      setLoading(false);
      Swal.fire({
        title: "Error",
        text: "Upload failed",
        icon: "error",
        confirmButtonText: "OK",
      });

      setStatus("Upload failed. Check backend.");
    }
  };

  const handleSubmitDaily = async (values: any) => {
        if (!captured){ 
           Swal.fire({
            title: "Error",
            text: "Photo not captured",
            icon: "error",
            confirmButtonText: "OK",
          })
          return;
        }
        setStatus("Uploading...");
        setLoading(true);
    
        try {
          const blob = await (await fetch(captured)).blob();
          const photData = new FormData();
          photData.append("photo", blob, "blink.jpg");
          const doctorregInfo = {
            eventId: eventId,
            doctorId: doctorId,
            attendanceRole: values.attendanceRole,
            doctorName:doctorName ,
            latitude: latitude,
            longitude: longitude,
            createdon: moment().format('YYYY-MM-DD'),
            posttime: moment().format('h:mm:ss'),
          }
          photData.append("doctorregInfo", JSON.stringify(doctorregInfo));
    
          const { success, message, data } = await eventService.saveDoctorPhoto(photData);
          if (success) {
            setLoading(false);
            Swal.fire({
            title: "success",
            text: message,
            icon: "success",
            confirmButtonText: "OK",
          });
          
          }else{
            Swal.fire({
            title: "Error",
            text: message,
            icon: "error",
            confirmButtonText: "OK",
          });
  
          }
          navigate(routes.eventDocInfo);
        } catch (err) {
          alert(err);
          setLoading(false);
          Swal.fire({
            title: "Error",
            text: "Upload Failed",
            icon: "error",
            confirmButtonText: "OK",
          });
          setStatus("Upload failed. Check backend.");
        }
      };
  // ---------------- UI ----------------
  const fetchDoctorByFmr = async (fmrNo: string, setFieldValue: any) => {
    if (!fmrNo) return;
    setFmrLoading(true);
    setHasMobileLookupData(false);
    setHasFmrNameData(false);
    setHasFmrEmailData(false);
    setHasFmrMobNoData(false);
    try {
      const res = await fetch(
        `https://api.regonlinetsmc.in/tsmc/api/v1/common/getDoctorDetailsByFmrNo?fmrNo=${encodeURIComponent(
          fmrNo
        )}`
      );
      const data = await res.json();
      const payload = data?.data ?? data?.result ?? data;
      const name = (payload?.fullname ?? "").toString().trim();
      const email = (payload?.emailid ?? "").toString().trim();
      const mobile = (payload?.mobileno ?? "").toString().trim();
      setFieldValue("doctorRegion", "telangana");
      if (name!==null&&name.length>0){ 
        setFieldValue("name", name);
        setHasFmrNameData(true);
      }else{
        setHasFmrNameData(false);
      }
      if (email!==null &&email.length>0){
        setFieldValue("email", email);
        setHasFmrEmailData(true);
      } else{
       setHasFmrEmailData(false);
      }
      if (mobile!==null &&mobile.length>0){
         setFieldValue("mobileNo", mobile);
         setHasFmrMobNoData(true);
      }else{
          setHasFmrMobNoData(false);
      }

    } catch (err) {
      Swal.fire("Error", "Unable to fetch doctor details", "error");
      setHasFmrNameData(false);
      setHasFmrEmailData(false);
      setHasFmrMobNoData(false);
    } finally {
      setFmrLoading(false);
    }
  };

  const fetchDoctorByMobile = async (mobileNo: string, setFieldValue: any) => {
    const trimmedMobile = (mobileNo ?? "").toString().trim();
    if (!/^[0-9]{10}$/.test(trimmedMobile)) return;
    setMobileLookupLoading(true);
    setHasMobileLookupData(false);
    try {
      const { success, data } = await eventService.getDoctorDetailsByApprovalAndContactNumber("pen", trimmedMobile);
      const payload = Array.isArray(data) ? data[0] : data;
      if (!success || !payload) {
        Swal.fire("Info", "No doctor found for this mobile number", "info");
        return;
      }

      const name = (payload?.doctorName ?? "").toString().trim();
      const email = (payload?.email ?? "").toString().trim();
      const fmrNo = (payload?.fmrNo ?? "").toString().trim().toUpperCase();
      const contactNumber = (payload?.contactNumber ?? trimmedMobile).toString().trim();
      const resolvedRegion = resolveDoctorRegion(payload, fmrNo);
      const resolvedAttendanceRole = resolveAttendanceRole(payload);

      setFieldValue("mobileNo", contactNumber);
      if (name.length > 0) setFieldValue("name", name);
      if (email.length > 0) setFieldValue("email", email);
      if (fmrNo.length > 0) setFieldValue("fmrNo", fmrNo);
      if (resolvedRegion) setFieldValue("doctorRegion", resolvedRegion);
      if (resolvedAttendanceRole) setFieldValue("attendanceRole", resolvedAttendanceRole);

      setHasMobileLookupData(true);
      setHasFmrNameData(name.length > 0);
      setHasFmrEmailData(email.length > 0);
      setHasFmrMobNoData(contactNumber.length > 0);
    } catch (err) {
      Swal.fire("Error", "Unable to fetch doctor details by mobile number", "error");
      setHasMobileLookupData(false);
    } finally {
      setMobileLookupLoading(false);
    }
  };

  return (
    <div className="container py-5">
      <div className="card shadow-lg p-4">
        <h3 className="text-center mb-4 cme-header fw-bold">
          Doctor Registration
        </h3>

        {token && (
          <div style={{ background: "#e3f2fd", padding: 8, marginBottom: 10 }}>
            Delegate Mode: Capturing attendance on behalf of organization
          </div>
        )}

        <div className="row">
          {/* LEFT SIDE: Webcam Capture */}
          <div className="col-md-5 d-flex flex-column align-items-center border-end">
            <div style={{ padding: 0, textAlign: "center" }}>


            <div className="d-flex flex-column align-items-center gap-2 mb-3" style={{ minWidth: 220 }}>
              {!cameraActive && !captured && (
                <button
                  className="btn btn-primary w-100"
                  onClick={() => setCameraActive(true)}
                >
                  Caputure Photo
                </button>
              )}
              <button
                className="btn btn-outline-info rounded-circle"
                style={{ width: 46, height: 46, display: "flex", alignItems: "center", justifyContent: "center" }}
                onClick={toggleCamera}
                title={`Switch to ${facingMode === "user" ? "Rear" : "Front"} camera`}
                aria-label="Switch camera"
              >
                {facingMode === "user" ? "📷" : "📸"}
              </button>
              <span style={{ fontSize: 12, color: "#6c757d" }}>Current: {facingMode === "user" ? "Front" : "Rear"}</span>
            </div>

            {cameraActive && (
              <div>
                <video
                  ref={videoRef}
                  autoPlay
                  playsInline
                  muted
                  width={300}
                  height={300}
                  style={{
                    borderRadius: 8,
                    border: "2px solid #ccc",
                    display: photoReady ? "none" : "block",
                  }}
                />

                {!photoReady && (
                  <>
                    <p
                      style={{
                        fontSize: "1.1em",
                        marginTop: 8,
                        color: isBlinking ? "red" : "green",
                      }}
                    >
                      {status}
                    </p>
                    <div className="d-flex gap-2 justify-content-center">
                      <button
                        className="btn btn-warning"
                        // Allow manual capture even if face mesh misses the face occasionally
                        onClick={() => {
                          setStatus("Capturing...");
                          capturePhoto(false, false);
                        }}
                      >
                        Capture Manually
                      </button>
                    </div>
                  </>
                )}
              </div>
            )}

              <canvas ref={canvasRef} style={{ display: "none" }} />

              {captured && (
                <div style={{ marginTop: 0 }}>
                  <h4>Captured Photo:</h4>
                  <img
                    src={captured}
                    alt="Captured"
                    style={{
                      width: "100%",
                      maxWidth: 300,
                      borderRadius: 8,
                      border: "2px solid #888",
                    }}
                  />
                  <div style={{ marginTop: 15, display: "flex", gap: "10px", justifyContent: "center" }}>
                    {/*<button
              onClick={uploadPhoto}
              style={{
                padding: "10px 20px",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: 6,
                cursor: "pointer",
                fontSize: "1em",
              }}
            >
              Upload Photo
            </button> */}
                    <button
                      onClick={resetCapture}
                      style={{
                        padding: "10px 20px",
                        backgroundColor: "#f44336",
                        color: "#fff",
                        border: "none",
                        borderRadius: 6,
                        cursor: "pointer",
                        fontSize: "1em",
                      }}
                    >
                      Recapture
                    </button>
                  </div>
                </div>
              )}
            </div>
</div>


          
          {/* RIGHT SIDE: Registration Form */}
            {<div className="col-md-7">
              <Formik
                enableReinitialize
                initialValues={{
                  eventId: eventId ? String(eventId) : "",
                  attendanceRole: "",
                  doctorRegion: "",
                  name: doctorName || "",
                  fmrNo: "",
                  email: "",
                  mobileNo: "",
                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({ setFieldValue, values, errors, touched, isSubmitting }) => (
                  <Form noValidate>
                    <div className="mb-3">
                      <div className="col-md-4">
                        <label className="form-label"><b>Event Name *</b></label>
                        <Field as="select" name="eventId" className="form-select">
                          <option value="">Select</option>
                          {eventTypes &&
                            <option key={eventTypes.id} value={eventTypes.id} >
                              {eventTypes.nameOfEvent}
                            </option>
                          }
                        </Field>
                        <div className="text-danger small">
                          <ErrorMessage name="eventId" />
                        </div>
                      </div>
                      <div className="col-md-4">
                        <label className="org-info-item"> Attending as</label>
                        <Field as="select" name="attendanceRole" className="form-select">
                          <option value="">-- Select--</option>
                          <option key={1} value="delegate"> Delegate</option>
                          <option key={2} value="speaker">Speaker</option>
                        </Field>
                        <div className="text-danger small">
                          <ErrorMessage name="attendanceRole" />
                        </div>
                      </div>

                      <div className="col-md-4">
                        <label className="org-info-item">State</label>
                        <Field as="select" name="doctorRegion"
                                onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                  const nextRegion = e.target.value;
                                  setHasFmrNameData(false);
                                  setHasFmrEmailData(false);
                                  setHasFmrMobNoData(false);
                                  setHasMobileLookupData(false);
                                  setFieldValue("doctorRegion", nextRegion);
                                  setFieldValue("fmrNo", "");
                                  setFieldValue("name", "");
                                  setFieldValue("email", "");
                                  setFieldValue("mobileNo", "");
                                }}
                        className="form-select">
                          <option value="">-- Select --</option>
                          <option value="telangana">Telangana</option>
                          <option value="non-telangana">Non Telangana</option>
                        </Field>
                        <div className="text-danger small">
                          <ErrorMessage name="doctorRegion" />
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                          <label className="form-label fw-semibold">Mobile No</label>
                          <Field name="mobileNo">
                            {({ field, form }: any) => (
                              <input
                                {...field}
                                className="form-control"
                                placeholder={hasFmrMobNoData ? "Auto-filled from FMR" : "Enter 10-digit mobile number"}
                                //disabled={hasFmrMobNoData}
                                value={
                                  values.doctorRegion === "telangana" && !mobileFocused
                                    ? maskMobileDisplay(field.value)
                                    : field.value
                                }
                                onChange={(e) => {
                                  setHasMobileLookupData(false);
                                  form.setFieldValue(field.name, e.target.value);
                                }}
                                onFocus={() => setMobileFocused(true)}
                                onBlur={(e) => {
                                  setMobileFocused(false);
                                  field.onBlur(e);
                                  const raw = (field.value ?? "").toString().trim();
                                  form.setFieldValue(field.name, raw);
                                }}
                              />
                            )}
                          </Field>
                          {isSubsequentDayFlow && (
                            <button
                              type="button"
                              className="btn btn-danger mt-2"
                              disabled={mobileLookupLoading || !/^[0-9]{10}$/.test((values.mobileNo ?? "").toString().trim())}
                              onClick={() => fetchDoctorByMobile(values.mobileNo, setFieldValue)}
                            >
                              {mobileLookupLoading ? "Searching..." : "Search by Mobile"}
                            </button>
                          )}
                          {isSubsequentDayFlow && hasMobileLookupData && (
                            <div className="text-success small mt-1">Doctor details auto-filled from mobile search</div>
                          )}
                      </div>
                    
                      <div className="mb-3">
                        <label className="form-label fw-semibold">FMR Number</label>
                         <Field
                           name="fmrNo"
                           className="form-control"
                           placeholder="Enter FMR Number"
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                             setHasFmrNameData(false);
                             setHasFmrEmailData(false);
                             setHasFmrMobNoData(false);
                             setHasMobileLookupData(false);
                            setFieldValue("fmrNo", e.target.value.toUpperCase());
                          }}
                           onBlur={(e: any) => setFieldValue("fmrNo", e.target.value?.trim().toUpperCase())}
                         />
                        {values.doctorRegion === "telangana" && (
                         <button
                        type="button"
                        className="btn btn-primary"
                        disabled={fmrLoading || !values.fmrNo}
                        onClick={() => {
                          const v = values.fmrNo?.trim();
                          if (v) {
                            fetchDoctorByFmr(v, setFieldValue);
                          }
                        }}
                      >
                        {fmrLoading ? "Fetching..." : "Fetch"}
                      </button>
                        )}
                        <ErrorMessage
                          name="fmrNo"
                          component="div"
                          className="text-danger small"
                        />
                      </div>

                    {values.doctorRegion !== "telangana" && (
                      <>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Name</label>
                          <Field
                            name="name"
                            className="form-control"
                            placeholder="Enter full name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label fw-semibold">Email</label>
                          <Field name="email">
                            {({ field, form }: any) => (
                              <input
                                {...field}
                                type={values.doctorRegion === "telangana" ? "text" : "email"}
                                className="form-control"
                                placeholder="Enter email"
                                value={
                                  values.doctorRegion === "telangana" && !emailFocused
                                    ? maskEmailDisplay(field.value)
                                    : field.value
                                }
                                onChange={(e) => form.setFieldValue(field.name, e.target.value)}
                                onFocus={() => setEmailFocused(true)}
                                onBlur={(e) => {
                                  setEmailFocused(false);
                                  field.onBlur(e);
                                  const raw = (field.value ?? "").toString().trim();
                                  form.setFieldValue(field.name, raw);
                                }}
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="email"
                            component="div"
                            className="text-danger small"
                          />
                        </div>

                        
                      </>
                    )}

                    {values.doctorRegion === "telangana" && (
                      <>
                        
                        
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Name</label>
                          <Field
                            name="name"
                            className="form-control"
                            placeholder={hasFmrNameData ? "Auto-filled from FMR" : "Enter full name"}
                            //disabled={hasFmrNameData}
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-semibold">Email</label>
                          <Field name="email">
                            {({ field, form }: any) => (
                              <input
                                {...field}
                                type={values.doctorRegion === "telangana" ? "text" : "email"}
                                className="form-control"
                                placeholder={hasFmrEmailData ? "Auto-filled from FMR" : "Enter email"}
                                //disabled={hasFmrEmailData}
                                value={
                                  values.doctorRegion === "telangana" && !emailFocused
                                    ? maskEmailDisplay(field.value)
                                    : field.value
                                }
                                onChange={(e) => form.setFieldValue(field.name, e.target.value)}
                                onFocus={() => setEmailFocused(true)}
                                onBlur={(e) => {
                                  setEmailFocused(false);
                                  field.onBlur(e);
                                  const raw = (field.value ?? "").toString().trim();
                                  form.setFieldValue(field.name, raw);
                                }}
                              />
                            )}
                          </Field>
                        </div>
                        
                      </>
                    )}

                    <div className="d-grid">
                      <button type="submit" className="cme-button w-100" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                      </button>

                    </div>
                  </Form>
                )}

              </Formik>
            </div>}
            
          </div>
          </div>
        </div>
    
    );
};
export default CameraCapture;

function getEyeAspectRatio(landmarks: any[]): number {
  const top = landmarks[159];
  const bottom = landmarks[145];
  const left = landmarks[33];
  const right = landmarks[133];

  const vertical = Math.hypot(top.x - bottom.x, top.y - bottom.y);
  const horizontal = Math.hypot(left.x - right.x, left.y - right.y);
  return vertical / horizontal;
}





